import script from "./PipedValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./PipedValue.vue?vue&type=script&setup=true&lang=ts"

import "./PipedValue.vue?vue&type=style&index=0&id=d629551a&lang=scss"

const __exports__ = script;

export default __exports__